import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Message} from '../model/message';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import {TerminDetail} from '../model/TerminDetail';
import {NastenkaDetail} from '../model/NastenkaDetail';

@Component({
    selector: 'app-nastenka-detail',
    templateUrl: './nastenka-detail.component.html',
    styleUrls: ['./nastenka-detail.component.css'],
    standalone: false
})
export class NastenkaDetailComponent implements OnInit
{
  loading = true;
  private message: Message;
  public detail: NastenkaDetail;

  constructor(
      public dialogRef: MatDialogRef<NastenkaDetailComponent>,
      @Inject(MAT_DIALOG_DATA) public data: {message: Message},
      private http: HttpClient,
      private appService: AppService,
      private translation: TranslateService
  )
  {
  }

  ngOnInit(): void
  {
    this.message = this.data.message;

    const url = '/ais/rest/portal/nastenka/odkaz/' + this.message.id;

    this.http.get<NastenkaDetail>(url)
        .subscribe({
          next: (data) => {
            this.detail = data;
            this.loading = false;
          },
          error: (error) => {
            this.appService.openErrorDialog(error.error.message);
          }
        });
  }

}
